import { cn, type createStyleType, inputThemeableVars } from '@ctct/summit-core';
import { Command as CommandPrimitive } from 'cmdk';
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react';

const themeableVars = [
  ...inputThemeableVars.textfield,
  'r:[--bg:var(--sds-input-bg-default)]',
  'r:[--border:theme(selectContent.border.default)]',
  'r:[--height:var(--sds-input-height-md)]',
  'r:[--separator:theme(selectContent.border.default)]',
  'r:[--item-bg-selected:theme(selectItem.bg.selected)]',
  'r:[--item-text-selected:theme(selectItem.text.selected)]',
] as const;
type CommandSyle = ReturnType<typeof createStyleType<typeof themeableVars>>;

interface CommandProps extends ComponentPropsWithoutRef<typeof CommandPrimitive> {
  /** Set inline styles, including the component's built-in CSS variables.  */
  style?: CommandSyle;
}

/**
 * Parent container for command component
 */
const Command = forwardRef<ElementRef<typeof CommandPrimitive>, CommandProps>(
  ({ className, ...props }, ref) => {
    const classes = cn(
      'rds-command',
      themeableVars.join(' '),
      `
        r:bg-(--bg)
        r:text-(--text)
        r:border-(--border)
        r:flex r:h-full r:w-full r:flex-col r:overflow-hidden
        r:border r:rounded-lg r:shadow-md
      `,
      className
    );
    return <CommandPrimitive ref={ref} className={classes} data-sds-id="command" {...props} />;
  }
);
Command.displayName = CommandPrimitive.displayName;

export { Command, type CommandProps };
